module.exports = __webpack_public_path__ + "img/referral.ac9e4688.png";